import React from "react";
import { Link } from "react-router-dom";
import { bookingAgreement } from "../data/bookingAgreement";

function AgreementAcceptance({ accepted, onAcceptedChange }) {
  return (
    <section className="agreement-acceptance">
      <div className="agreement-acceptance-heading">
        <span className="agreement-document-icon" aria-hidden="true">
          ✦
        </span>

        <div>
          <h3>Before You Book</h3>
          <p>
            Please review our policies before requesting
            your appointment.
          </p>
        </div>
      </div>

      <ul className="agreement-summary">
        {bookingAgreement.summary.map((item) => (
          <li key={item.title}>
            <strong>{item.title}</strong>
            <span>{item.description}</span>
          </li>
        ))}
      </ul>

      <Link
        to="/booking-agreement"
        target="_blank"
        rel="noopener noreferrer"
        className="agreement-read-link"
      >
        Read the Full Booking Agreement
        <span aria-hidden="true"> ↗</span>
      </Link>

      <label className="agreement-checkbox">
        <input
          type="checkbox"
          checked={accepted}
          onChange={(event) =>
            onAcceptedChange(event.target.checked)
          }
          required
        />

        <span>
          I have read and agree to the{" "}
          <Link
            to="/booking-agreement"
            target="_blank"
            rel="noopener noreferrer"
          >
            Booking Agreement
          </Link>
          .
        </span>
      </label>

      {!accepted && (
        <p className="agreement-required-message">
          Acceptance is required to submit your appointment request.
        </p>
      )}
    </section>
  );
}

export default AgreementAcceptance;